import { eventTypeEnum } from '../enums/eventTypeEnum';
import { resourceTypes } from '../enums/resourceTypes';
import { eventResponseStatus } from '../enums/eventResponseStatus';
import { CalendarEventModel } from '../models/calendarEvent.model';
import { CalendarResourceModel } from '../models/calendarResource.model';

class CalendarUtil {
  getPrimaryLocation(extendedProps) {
    let location = '';
    const additionalLocations =
      extendedProps.additionalResources?.filter(
        resource => resource.resourceCategory.resourceType === resourceTypes.LOCATION
      ) || [];

    if (extendedProps.primaryResource != null) {
      location = extendedProps.primaryResource.name;
    } else if (extendedProps.primaryResourceText != null) {
      location = extendedProps.primaryResourceText;
    } else if (additionalLocations.length > 0) {
      location = additionalLocations[0].name;
    } else if (extendedProps.additionalResourceText != null) {
      location = extendedProps.additionalResourceText;
    }
    return location;
  }

  mapResource({
    id,
    name,
    institutionCode,
    institutionName,
    resourceCategory,
    numberOfOccurrences,
    numberOfAvailableOccurrences,
  }) {
    return {
      label: `${name} (${institutionName})`,
      value: id,
      name: name,
      resourceType: resourceCategory.resourceType,
      resourceCategory: resourceCategory.name,
      id: id,
      institutionCode: institutionCode,
      numberOfOccurrences,
      numberOfAvailableOccurrences,
    };
  }

  /**
   * @description checks if given event was declined by given profile user Id when profile Id equals  given resource Id
   * @param  {CalendarEventModel} event - event to be checked
   * @param  {number} profileId - profile id of current user
   * @param  {number} delegatedContextId - delegated context profile id
   * @param  {CalendarResourceModel[]} resources - list of chosen resources
   * @param  {string} resourceId - resourceId to be checked
   * @return  {boolean} - returns true if conditions are met:
   *                                current profile id (can be delegated) equals given profile resourceId and
   *                                resourceId can be found in given chosen resources and
   *                                the event is declined,
   *                 false - otherwise
   */
  isEventDeclinedByUser(
    event: CalendarEventModel,
    profileId: number | string,
    delegatedContextId: number | string,
    resources: CalendarResourceModel[],
    resourceId: string
  ): boolean {
    const userProfileId = delegatedContextId ? delegatedContextId : profileId;
    const resource = resources.find(resource => resource.id === resourceId);
    const eventBelongsToUser = userProfileId == resource?.singleId;
    const isDeclined = event.responseStatus === eventResponseStatus.DECLINED;

    return eventBelongsToUser && isDeclined;
  }

  /**
   * @description checks if the event is a parental meeting
   * @return {boolean}
   * @param type
   */
  getIsParentalMeeting(type: eventTypeEnum): boolean {
    return [eventTypeEnum.SCHOOL_HOME_MEETING, eventTypeEnum.PARENTAL_MEETING].includes(type);
  }
}

export const calendarUtil = new CalendarUtil();
